var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/well-known-symbol-wrapped.js
// module id = 288
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33